<template>
  <div style="clear: left;">
    <div class="product" ref="product">
      <div class="product-header">
        <div class="header-img-wrapper">
          <img class="product-img" :src="productInfo.icon">
        </div>
        <div class="header-title">{{ productInfo.displayName }}</div>
      </div>
      <div class="region-table" ref="regionTable">
        <div class="region-row" v-for="rowNum in regionRowNum" :key="rowNum">
          <template v-for="colNum in 5">
            <product-region v-if="productInfo.rankings[(rowNum - 1) * 5 + (colNum - 1)]" :key="(rowNum - 1) * 5 + (colNum - 1)" :regionInfo="productInfo.rankings[(rowNum - 1) * 5 + (colNum - 1)]" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductRegion from './ProductRegion.vue';

export default {
  name: 'Product',
  components: {
    ProductRegion,
  },
  props: ['productInfo'],
  mounted() {
    this.$nextTick(() => {
      const count = this.productInfo.rankings ? this.productInfo.rankings.length : 0;
      if (count > 0 && count < 5) {
        const perRegionWidth = this.$refs.regionTable.offsetWidth / count;
        this.$refs.product.style.minWidth = `${perRegionWidth * 5}px`;
      }
    });
  },
  computed: {
    regionRowNum: function() {
      if (!this.productInfo.rankings) {
        return 1;
      }

      return Math.ceil(this.productInfo.rankings.length / 5) || 1;
    },
  },
}
</script>

<style scoped>
.product {
  border-collapse: collapse;
  border-spacing: 0px;
  margin: 20px 0px;
  display: inline-block;
  float: left;
}

.product-header {
  width: 100%;
  border: 2px solid;
  background-color: #fed35b;
  font-weight:bold;
  height: 100px;
  text-align: center;
  width: inherit;
  display: flex;
}

.header-img-wrapper {
  width: 0%;
}

.header-title {
  width: 100%;
  padding: 40px 0;
}

.title-col {
  position: relative;
}

.product-img {
  height: 80px;
  max-width: 80px;
  margin-left: 10px;
  margin-top: 10px;
}

.region-table {
  display: table;
  border-collapse: collapse;
  box-sizing: border-box;
}

.region-row {
  display: table-row;
}
</style>
